import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import OutsideClickHandler from "react-outside-click-handler";
import styled from 'styled-components';
import { purpurColorFunctionalWhite, purpurColorPurple800, purpurColorRed600, } from '@purpurds/tokens/color/variables';
import { PurPurButton } from 'components/button';
import { Icon } from '@purpurds/purpur/icon';
import { icons } from 'theme/icons';
import spacing from 'theme/spacing';
const StyledSerialNumberInput = styled.div `
  display: flex;
  flex-direction: row;
  border-left: 6px solid ${props => props.$isError ? purpurColorRed600 : purpurColorPurple800};
  border-bottom: 1px solid #d3d3d3;
  width: 100%;
  box-sizing: border-box;
  position: relative;
  border-radius: 0 0 4px 4px;
`;
const StyledTextArea = styled.div `
  display: flex;
  flex-grow: 1;
  flex-direction: column;
`;
const StyledInputField = styled.div `
  display: flex;
  flex-grow: 1;
`;
const StyledInput = styled.input `
  font-weight: 300;
  font-size: 18px;
  border: none;
  outline: none;
  width: 100%;
  height: 48px;
  border-bottom: 0;
  border-radius: 0;
  line-height: 35px;
  text-indent: 12px;
  padding: 0;
  background-color: ${purpurColorFunctionalWhite};
`;
const StyledError = styled.div `
  color: ${purpurColorRed600};
  background-color: ${purpurColorFunctionalWhite};
  padding: 0 ${spacing.spacing12} ${spacing.spacing8};
`;
const StyledPurPurButton = styled(PurPurButton) `
  border-radius: 0 0 4px 0;
`;
export const SerialNumberInput = ({ id, isFetching = false, errorMessage = '', value = '', showScannerIcon = false, onScannerClick, onReset, handleChange, handleSubmit, }) => {
    const onKeyDown = (e) => {
        if (e.key === 'Enter')
            handleSubmit(e);
        if (e.key === 'Escape')
            onReset(id);
    };
    const onOutsideClick = () => {
        if (!errorMessage && value) {
            handleSubmit();
        }
    };
    const showError = Boolean(errorMessage) && !isFetching;
    const hasValue = value !== '' && value !== null && value !== undefined;
    return (_jsx(OutsideClickHandler, { onOutsideClick: onOutsideClick, children: _jsxs(StyledSerialNumberInput, { "$isError": !!errorMessage, children: [_jsxs(StyledTextArea, { children: [_jsx(StyledInputField, { children: _jsx(StyledInput, { type: "text", value: value || '', name: String(id), placeholder: "Mac/serienummer", onChange: handleChange, onKeyDown: onKeyDown, disabled: isFetching }) }), showError && _jsx(StyledError, { children: errorMessage })] }), hasValue && (_jsx(StyledPurPurButton, { size: "md", type: "button", variant: !!errorMessage ? "destructive" : "primary", onClick: () => onReset(id), children: _jsx(Icon, { svg: icons.close }) })), !hasValue && showScannerIcon && (_jsx(StyledPurPurButton, { size: "md", type: "button", variant: "primary", onClick: onScannerClick, children: _jsx(Icon, { svg: icons.scan }) }))] }) }));
};
